/**
 * @fileoverview Resale vendor template implementation for order management.
 * Provides the Resale-specific order page component and configuration for resale market operations.
 *
 * @author Web Analysis Team
 * @version 1.0.0
 */

import React from 'react';
import OrderBase from '../order-base';
import { create as createSpecificVendor } from '../order-base/vendor';

/**
 * Resale order management component.
 * Renders the main order interface specifically configured for Resale market vendor operations.
 *
 * @returns {JSX.Element} The Resale order management interface
 */
const ResaleOrder: React.FC = () => {
    const specificVendor = createSpecificVendor('Resale');
    return (
        <OrderBase
            vendor={specificVendor}
        >

        </OrderBase>
    );
};

/**
 * Resale order page configuration object.
 * Defines the page name and list component for the Resale order management system.
 *
 * @type {Object}
 * @property {string} name - The display name for this vendor page
 * @property {React.Component} list - The main list/management component
 */
const ResaleOrderPage = {
    name: 'Resale',
    list: ResaleOrder
};

export default ResaleOrderPage;